import Button from '@mui/material/Button';
import React from 'react';

interface AcceptButtonProps {
  className?: string;
  label?: string;
  onClick: () => void;
}

function AcceptButton({ className, label, onClick }: AcceptButtonProps): JSX.Element {
  return (
    <Button variant='contained' color='primary' className={className} onClick={onClick}>
      {label}
    </Button>
  );
}

AcceptButton.defaultProps = {
  className: undefined,
  label: 'Accept',
};

export default AcceptButton;
